import { render, staticRenderFns } from "./EmrSelector.vue?vue&type=template&id=595f316f"
import script from "./EmrSelector.vue?vue&type=script&lang=js"
export * from "./EmrSelector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports